import {
  Button,
  Container,
  Flex,
  Badge,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  Center,
  Tabs,
  Tab,
  TabList,
  MenuList,
  Text,
  useBreakpointValue,
  useTheme,
  MenuDivider,
} from '@chakra-ui/react'
import {solid} from '@fortawesome/fontawesome-svg-core/import.macro'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {getAuth} from 'firebase/auth'
import {isEmpty} from 'lodash'
import Link from 'next/link'
import {useRouter} from 'next/router'
import React, {useEffect} from 'react'
import {fetchLogout} from '../../fetchers/auth'
import {sessionStore} from '../../stores/session/sessionStore'
import {IconLogo} from '../../styles/Icons'
import {isDevOrPreview} from '../../utils/consts'
import {
  ROUTE_ADMIN,
  ROUTE_LOGIN,
  ROUTE_OVERVIEW,
  ROUTE_PROFILE,
  ROUTE_ROOT,
  ROUTE_WHAT_S_NEXT,
} from '../../utils/Routes'
import useCurrentTodos from '../../utils/useCurrentTodos'

const NavBar = () => {
  const router = useRouter()
  const theme = useTheme()
  const user = sessionStore(state => state.user)
  const currentSimulation = sessionStore(state => state.currentSimulation)
  const isDesktop = useBreakpointValue({base: false, lg: true})
  const [tabIndex, setTabIndex] = React.useState(0)
  const {todos} = useCurrentTodos()

  useEffect(() => {
    setTabIndex(
      (currentSimulation
        ? [ROUTE_ROOT, ROUTE_OVERVIEW, ROUTE_WHAT_S_NEXT, ROUTE_ADMIN]
        : [ROUTE_ROOT, ROUTE_ADMIN]
      ).indexOf(router.pathname)
    )
  }, [user, router, currentSimulation])

  const logout = async () => {
    await fetchLogout()
    await router.push(ROUTE_LOGIN)
  }

  return (
    <Container position='sticky' top='0' zIndex={2} backgroundColor='white' boxShadow='md'>
      <Flex h='64px' alignItems='center' justifyContent='space-between'>
        <Link href={ROUTE_ROOT} passHref>
          <a>
            <IconLogo height='40px' />
          </a>
        </Link>
        <Flex alignItems='center'>
          {user && isDesktop && (
            <Center position='absolute' left='calc(50% - 350px)' w='700px'>
              <Tabs index={tabIndex} onChange={setTabIndex} variant='menu'>
                <TabList border='none'>
                  <Tab onClick={() => router.push(ROUTE_ROOT)}>Playground</Tab>
                  {currentSimulation && (
                    <Tab onClick={() => router.push(ROUTE_OVERVIEW)}>Global overview</Tab>
                  )}
                  {!isEmpty(todos) && (
                    <Tab position='relative' onClick={() => router.push(ROUTE_WHAT_S_NEXT)}>
                      What's next
                      {todos.filter(t => !t.read).length > 0 && (
                        <Badge
                          colorScheme='red'
                          variant='solid'
                          pl={3}
                          pr={3}
                          pt={1}
                          pb={1}
                          borderRadius='big'
                          pos='absolute'
                          top={-1.5}
                          right={-1.5}>
                          {todos.filter(t => !t.read).length}
                        </Badge>
                      )}
                    </Tab>
                  )}
                  {user?.isAdmin() && <Tab onClick={() => router.push(ROUTE_ADMIN)}>Admin</Tab>}
                </TabList>
              </Tabs>
            </Center>
          )}
          <Menu>
            {!user ? (
              <MenuButton as={Button} variant='primary' onClick={() => router.push(ROUTE_LOGIN)}>
                Login
              </MenuButton>
            ) : (
              <>
                <MenuButton as={Button} variant='primary'>
                  <HStack spacing={2}>
                    <FontAwesomeIcon
                      icon={isDesktop ? solid('user') : solid('bars')}
                      color={theme.colors.brand.white}
                    />
                    {user && isDesktop && <Text>{user.displayName()}</Text>}
                  </HStack>
                </MenuButton>
                <MenuList alignItems='center'>
                  {!isDesktop && (
                    <>
                      <MenuItem onClick={() => router.push(ROUTE_ROOT)}>Playground</MenuItem>
                      {currentSimulation && (
                        <MenuItem onClick={() => router.push(ROUTE_OVERVIEW)}>
                          Global overview
                        </MenuItem>
                      )}
                      {!isEmpty(todos) && (
                        <MenuItem
                          position='relative'
                          onClick={() => router.push(ROUTE_WHAT_S_NEXT)}>
                          What's next
                          {todos.filter(t => !t.read).length > 0 && (
                            <Badge
                              colorScheme='red'
                              variant='solid'
                              pl={3}
                              pr={3}
                              pt={1}
                              pb={1}
                              borderRadius='big'
                              pos='absolute'
                              top={-1.5}
                              right={-1.5}>
                              {todos.filter(t => !t.read).length}
                            </Badge>
                          )}
                        </MenuItem>
                      )}
                      <MenuDivider />
                    </>
                  )}
                  <MenuItem onClick={() => router.push(ROUTE_PROFILE)}>Your profile</MenuItem>
                  {user.isAdmin() && (
                    <MenuItem onClick={() => router.push(ROUTE_ADMIN)}>Admin</MenuItem>
                  )}
                  {isDevOrPreview && (
                    <MenuItem onClick={() => router.push('/styleguide')}>Styleguide</MenuItem>
                  )}
                  {isDevOrPreview && (
                    <MenuItem>
                      <a
                        href={`https://console.firebase.google.com/u/0/project/doyourtax-dev/firestore/data/~2Fcustomers~2F${
                          getAuth().currentUser?.uid
                        }`}
                        target='_blank'
                        rel='noreferrer noopener'>
                        Firestore user
                      </a>
                    </MenuItem>
                  )}
                  <MenuItem onClick={logout}>Logout</MenuItem>
                </MenuList>
              </>
            )}
          </Menu>
        </Flex>
      </Flex>
    </Container>
  )
}

export default NavBar
